<template>
  <div id="vocabulary-terms-component">
    <div class="col-12">
      <div class="card-header">
        <strong>Terms in vocabulary</strong>
        <router-link
          class="btn btn-primary btn-sm pull-right"
          :to="{ name: 'VocabularyOrder', params: { id: $route.params.id }}"
        >
          Manage order
        </router-link>
      </div>
      <div class="card form-horizontal spinner-parent">
        <spinner ref="termsSpinner" size="md" text="Loading ..." />

        <div v-if="terms.isReady" class="row">
          <div class="col-12">
            <div class="card-block">
              <input
                v-model="terms.searchQuery"
                type="text"
                class="form-control"
                placeholder="Search by term title"
              >
            </div>

            <div class="card-block">
              <table class="terms-table table table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <td>ID</td>
                    <td>Name</td>
                    <td>Actions</td>
                  </tr>
                </thead>
                <tbody v-if="terms.list.length">
                  <tr v-for="item in terms.list" :key="item.id" :data-id="item.id">
                    <td>{{ item.id }}</td>
                    <td>
                      <div class="term-edit-wrap _static">
                        <span class="term-edit-span">{{ item.name }}</span>
                      </div>
                      <div class="term-edit-wrap _editing" style="display: none;">
                        <input
                          v-model="item.name"
                          type="text"
                          class="term-edit-field"
                          @keyup.enter="saveTerm(item)"
                        >
                        <button class="btn btn-sm btn-success" @click="saveTerm(item)">
                          Save <span class="btn-loader" style="display: none;" />
                        </button>
                      </div>
                    </td>
                    <td class="table-list__cell--narrow">
                      <button class="btn btn-primary term-btn-edit" @click="editTerm(item)">
                        Edit
                      </button>
                      <button
                        class="btn btn-primary term-btn-cancel-edit"
                        style="display: none"
                        @click="cancelEditTerm(item)"
                      >
                        Cancel Edit
                      </button>
                      <button class="btn btn-danger" @click="deleteTerm(item)">
                        Delete
                        <span class="btn-loader" style="display: none;" />
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="3">There are no content</td>
                  </tr>
                </tbody>
              </table>
              <div v-if="terms.total === 0">There are no Terms</div>
              <nav>
                <pager
                  :total="terms.pager.total"
                  :offset="terms.pager.offset"
                  :size="terms.pager.perPage"
                  @page-changed="changeTermsPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <div class="card-header">
        <strong>Create new term in vocabulary</strong>
      </div>
      <div class="card form-horizontal">
        <div class="row">
          <div class="col-12">
            <div class="card-block">
              <div class="form-group row">
                <div class="col-md-12">
                  <input
                    id="new_term"
                    v-model="terms.newTermName"
                    type="text"
                    placeholder="Enter term name"
                    class="form-control"
                  >
                </div>
              </div>
              <div class="form-group">
                <button type="button" class="btn btn-success btn-term-create" @click="createTerm">
                  Create
                  <span class="btn-loader" style="display: none;" />
                </button>
              </div>
              <div class="form-group">
                <div class="terms-saving-alerts" style="margin-top: 20px;">
                  <div v-if="terms.termCreateError === 'ok'" class="alert alert-success">
                    Term has created successful!
                  </div>
                  <div v-else-if="terms.termCreateError !== ''" class="alert alert-danger">
                    {{ terms.termCreateError }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Pager from '@/global/components/Pager';

export default {
  name: 'VocabularyTerms',

  components: {
    pager: Pager,
  },

  data() {
    return {
      terms: {
        searchQuery: '',
        isReady: false,
        source: [],
        list: [],
        newTermName: null,
        pager: {
          total: 0,
          offset: 0,
          perPage: 15,
        },
        termCreateError: '',
      },
    };
  },

  watch: {
    'terms.searchQuery': _.debounce(function () {
      this.terms.pager.offset = 0;
      this.getTerms();
    }, 400),
    'terms.pager.offset': function () {
      this.getTerms();
    },
  },

  mounted() {
    this.getTerms();
  },

  methods: {
    getTerms() {
      if (this.$refs.termsSpinner) { this.$refs.termsSpinner.show(); }
      const page = this.terms.pager.offset / this.terms.pager.perPage + 1;
      this.$apiHttp.get(`${this.$config.app_api.prefix}terms`, {
        params: {
          vid: this.$route.params.id,
          limit: this.terms.pager.perPage,
          search_string: this.terms.searchQuery,
          page,
        },
      }).then((response) => {
        this.terms.pager.total = response.data.meta.pagination.total;
        this.terms.pager.perPage = response.data.meta.pagination.per_page;

        const termsArr = _.cloneDeep(response.data);
        delete termsArr.meta;
        this.terms.source = Object.keys(termsArr).map(e => termsArr[e]);
        this.terms.list = _.cloneDeep(this.terms.source);
        this.terms.isReady = true;
        if (this.$refs.termsSpinner) { this.$refs.termsSpinner.hide(); }
      }).catch((error) => {
        console.error('Error in get terms of vocabulary query', error);
        if (this.$refs.termsSpinner) { this.$refs.termsSpinner.hide(); }
      });
    },
    deleteTerm(entity) {
      if (window.confirm(`Do you really want to delete term ${entity.title} with id = ${entity.id}?`)) {
        const $btnDeleteLoader = $(`table.terms-table tr[data-id="${entity.id}"] .btn-danger .btn-loader`);
        $btnDeleteLoader.show();
        this.$apiHttp.delete(`${this.$config.app_api.prefix}terms/${entity.id}`)
          .then(() => {
            console.log(`Term ${entity.title} with ID = ${entity.id} has deleted`);
            $btnDeleteLoader.hide();
            this.getTerms();
          })
          .catch((error) => {
            console.error('Error in term delete request', error);
            $btnDeleteLoader.hide();
          });
      }
    },
    isNewTermValid() {
      if (!this.terms.newTermName) {
        this.terms.termCreateError = 'Fill new term name';
        return false;
      }
      return true;
    },
    createTerm() {
      const postFormData = new FormData();
      const $btnCreateTermLoader = $('.btn-term-create .btn-loader');
      if (!this.isNewTermValid()) return;
      this.terms.termCreateError = '';
      $btnCreateTermLoader.show();
      postFormData.append('name', this.terms.newTermName);
      postFormData.append('vid', this.$route.params.id);
      this.$apiHttp.post(`${this.$config.app_api.prefix}terms`, postFormData)
        .then(() => {
          this.getTerms();
          $btnCreateTermLoader.hide();
          this.terms.termCreateError = 'ok';
        })
        .catch((error) => {
          console.error('Error in create term query ', error);
          $btnCreateTermLoader.hide();
          if (error.response.data.errors && error.response.data.errors.name) {
            [this.terms.termCreateError] = error.response.data.errors.name;
          } else {
            this.terms.termCreateError = 'Server error';
          }
        });
    },
    editTerm(term) {
      const $editTermRow = $(`.terms-table tr[data-id="${term.id}"]`);
      $editTermRow.find('.term-edit-wrap._static').hide();
      $editTermRow.find('.term-edit-wrap._editing').show();
      $editTermRow.find('.term-btn-cancel-edit').show();
      $editTermRow.find('.term-btn-edit').hide();
    },
    cancelEditTerm(term) {
      const editingTerm = term;
      editingTerm.name = _.find(this.terms.source, item => item.id === term.id).name;
      this.closeEditTerm(term);
    },
    closeEditTerm(term) {
      const $editTermRow = $(`.terms-table tr[data-id="${term.id}"]`);
      $editTermRow.find('.term-edit-wrap._static').show();
      $editTermRow.find('.term-edit-wrap._editing').hide();
      $editTermRow.find('.term-btn-cancel-edit').hide();
      $editTermRow.find('.term-btn-edit').show();
    },
    saveTerm(term) {
      const postFormData = new FormData();
      const $btnSaveTermLoader = $(`.terms-table tr[data-id="${term.id}"] .btn-success .btn-loader`);
      if (term.name === '') return;
      $btnSaveTermLoader.show();
      postFormData.append('name', term.name);
      postFormData.append('vid', this.$route.params.id);
      this.$apiHttp.post(`${this.$config.app_api.prefix}terms/${term.id}`, postFormData)
        .then(() => {
          $btnSaveTermLoader.hide();
          this.closeEditTerm(term);
        })
        .catch((error) => {
          console.error('Error in create term query ', error);
          $btnSaveTermLoader.hide();
        });
    },
    changeTermsPage(offset) {
      this.terms.pager.offset = offset;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Terms.vue?0bea587b